import axios from 'axios';
import { checkOnScreenEls } from '../../../../assets/src/js/common/on-screen';
import { showExpandable, hideExpandable } from '../../../../assets/src/js/common/expandable';

import '../sass/citrus-blog.scss';

(() => {
    const $citrusGalleries = document.querySelectorAll('.citrus-blog');

    if (!$citrusGalleries) return;

    $citrusGalleries.forEach($citrusBlog => {
        const $filterToggle = $citrusBlog.querySelector('.citrus-blog__filter-toggle');
        const $filterContent = $citrusBlog.querySelector('.citrus-blog__filter-content');
        const $filterClearAll = $citrusBlog.querySelector('.citrus-blog__filter-clear-all');
        const $filterForm = $citrusBlog.querySelector('.citrus-blog__filter-form');
        const $filterFormInputs = $filterForm?.querySelectorAll('input');

        const $featuredPost = $citrusBlog.querySelector('.citrus-blog__featured-post');

        const $grid = $citrusBlog.querySelector('.citrus-blog__grid');

        const $pagination = $citrusBlog.querySelector('.citrus-blog__pagination');

        const filterController = new AbortController();

        const setActiveFilter = ({
            activeCategories
        }) => {
            const $filterFormCategoryInputs = $filterForm?.querySelectorAll('[name="filter_categories[]"]');

            if ($filterFormCategoryInputs) {
                $filterFormCategoryInputs.forEach($filterFormCategoryInput => {
                    $filterFormCategoryInput.disabled = !$filterFormCategoryInput?.checked && (!activeCategories || !activeCategories.includes($filterFormCategoryInput.value));
                });
            }
        };

        const setFilterURLParams = ({
            blockAnchor,
            page,
            categories,
        }) => {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            params.delete('blog_page');
            params.delete('filter_categories[]');

            params.append('blog_page', page);

            if (categories?.length) {
                categories.forEach(category => {
                    params.append('filter_categories[]', category);
                });
            }

            window.history.replaceState(null, document.title, url.pathname + (params.toString() ? '?' + params.toString() : ''));
        };

        const submitFilterForm = () => {
            if (!$grid || !$filterForm) return;

            const $nonce = $filterForm.querySelector('[name="citrus_get_citrus_blog_posts_wpnonce"]');
            const $postId = $filterForm.querySelector('[name="post_id"]');
            const $blockAnchor = $filterForm.querySelector('[name="block_anchor"]');
            const $postsPerPage = $filterForm.querySelector('[name="posts_per_page"]');
            const $filterCategories = $filterForm.querySelectorAll('[name="filter_categories[]"]');

            const nonceValue = $nonce?.value;
            const postIdValue = $postId?.value;
            const blockAnchorValue = $blockAnchor?.value;
            const postsPerPageValue = $postsPerPage?.value;
            const filterCategoriesValues = $filterCategories ? 
                Array.from($filterCategories).filter($filterCategory => $filterCategory.checked).map($filterCategory => $filterCategory.value) : null;

            $grid.classList.add('citrus-blog__grid--loading');

            axios.get(GLOBALS.AJAX_URL, {
                params: {
                    action: 'citrus_ajax_get_blog_posts', 
                    nonce: nonceValue,
                    post_id: postIdValue,
                    block_anchor: blockAnchorValue,
                    posts_per_page: postsPerPageValue,
                    page: 1,
                    categories: filterCategoriesValues,
                },
                signal: filterController.signal,
            }).then(response => {
                if (!response?.data?.success) return;

                $grid.innerHTML = response?.data?.images ?? '';

                setFilterURLParams({
                    blockAnchor: blockAnchorValue,
                    page: 1,
                    categories: filterCategoriesValues,
                });

                setActiveFilter({
                    activeCategories: response?.data?.filters?.active_categories ?? [],
                });

                if (response?.data?.blog_posts) {
                    $grid.innerHTML = response.data.blog_posts;

                    checkOnScreenEls();
                }

                if ($featuredPost && response?.data?.featured_post) {
                    $featuredPost.innerHTML = response.data.featured_post;
                    
                    $featuredPost.classList.add('citrus-blog__featured-post--show');
                }

                if ($featuredPost && !response?.data?.featured_post) {
                    $featuredPost.innerHTML = '';
                    
                    $featuredPost.classList.remove('citrus-blog__featured-post--show');
                }

                if ($pagination && response?.data?.pagination) {
                    $pagination.innerHTML = response.data.pagination;
                }

                checkOnScreenEls();
            }).finally(() => {
                $featuredPost.classList.remove('citrus-blog__featured-post--loading');
                $grid.classList.remove('citrus-blog__grid--loading');
                $pagination.classList.remove('citrus-blog__pagination--loading');
            });
        };

        const initFilterClearAll = () => {
            if (!$filterClearAll) return;

            $filterClearAll.addEventListener('submit', e => {
                e.preventDefault();

                $filterFormInputs.forEach($filterFormInput => {
                    $filterFormInput.checked = false;
                });

                submitFilterForm();
            })
        };

        const initFilter = () => {
            if (!$filterToggle || !$filterContent) return;

            $filterToggle.addEventListener('click', () => {
                if ($filterContent.classList.contains('citrus-expandable--hide')) {
                    $filterToggle.classList.add('citrus-blog__filter-toggle--visible');

                    showExpandable($filterContent);
                } else {
                    $filterToggle.classList.remove('citrus-blog__filter-toggle--visible');
                    
                    hideExpandable($filterContent);
                }
            });

            $filterContent.addEventListener('expandableafterclose', () => {
                checkOnScreenEls();
            })

            $filterForm.addEventListener('submit', e => {
                e.preventDefault();

                submitFilterForm();
            });

            if ($filterFormInputs) {
                $filterFormInputs.forEach($filterFormInput => {
                    $filterFormInput.addEventListener('change', () => {
                        submitFilterForm();
                    });
                });
            }
        };

        initFilterClearAll();
        initFilter();
    });
})();
